import { render, staticRenderFns } from "./layout2-comp2.vue?vue&type=template&id=66d51062&"
import script from "./layout2-comp2.vue?vue&type=script&lang=js&"
export * from "./layout2-comp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports